import React from "react";
import ChatInput from "./ChatInput";
import { ArrowLeftIcon, InformationCircleIcon } from "@heroicons/react/24/outline";

interface Message {
    id: string;
    text: string;
    sender: string;
    timestamp: string;
}

interface Chat {
    id: string;
    name: string;
    messages: Message[];
}

interface ChatWindowProps {
    chat: Chat | null;
    onSend: (message: string) => void;
    isMobile?: boolean;
    onBack?: () => void;
    onInfo?: () => void;
}

const ChatWindow: React.FC<ChatWindowProps> = ({ chat, onSend, isMobile, onBack, onInfo }) => {
    return (
        <div className={`${isMobile ? "w-full" : "w-2/4 border-l border-r"} bg-white p-4 flex flex-col`}>
            {isMobile && (
                <div className="flex items-center justify-between mb-3 pb-2 border-b">
                    <button className="flex items-center gap-1 cursor-pointer" onClick={onBack}>
                        <ArrowLeftIcon className="w-5 h-5" />
                        <span className="font-medium">{chat?.name || "Chat"}</span>
                    </button>
                    <button onClick={onInfo}>
                        <InformationCircleIcon className="w-6 h-6" />
                    </button>
                </div>
            )}
            {/* Messages Area */}
            <div className="flex-1 overflow-y-auto space-y-4">
                {chat?.messages.map((message) => (
                    <div
                        key={message.id}
                        className={`flex ${message.sender === "You" ? "justify-end" : "justify-start"
                            }`}
                    >
                        <div className="fled flex-col gap-2">
                            <div
                                className={`max-w-xs message-tag rounded-lg shadow-md ${message.sender === "You"
                                    ? "bg-blue-500 text-white rounded-tr-none"
                                    : "bg-gray-200 text-black rounded-tl-none"
                                    }`}
                            >
                                <p className="text-sm">{message.text}</p>
                            </div>
                            <small className="text-xs opacity-70">{message.timestamp}</small>
                        </div>
                    </div>
                ))}
            </div>

            {/* Chat Input */}
            <div className="mt-4">
                <ChatInput onSend={onSend} />
            </div>
        </div>
    );
};

export default ChatWindow;
